import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "row-line" }, null, -1)
const _hoisted_2 = { class: "d-flex align-items-center row-content p-field-checkbox" }
const _hoisted_3 = {
  key: 0,
  class: "row-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", {
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setValue()))
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Checkbox, {
        disabled: _ctx.disabled,
        binary: true,
        inputId: _ctx.inputId,
        name: _ctx.name,
        modelValue: _ctx.checked
      }, null, 8, ["disabled", "inputId", "name", "modelValue"]),
      _createVNode("label", {
        class: "ml-2",
        for: _ctx.inputId
      }, _toDisplayString(_ctx.label), 9, ["for"])
    ]),
    (_ctx.last)
      ? (_openBlock(), _createBlock("div", _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}